/* eslint-disable @typescript-eslint/consistent-type-assertions */
import type { CommunicationStyle } from "@octopusdeploy/octopus-server-client";
import { CommunicationStyleValues, EndpointsHelper } from "@octopusdeploy/octopus-server-client";
import type { LinkHref } from "@octopusdeploy/portal-routes";
import { EndpointRegistrationKeyValues } from "@octopusdeploy/portal-routes";
import InternalLink from "~/components/Navigation/InternalLink";
import { getCommunicationStyleIconUrl } from "~/utils/MachineIconUrlFetchers/machineIconUrlFetchers";
import styles from "../style.module.less";
interface MachinesContentRowProps {
    deploymentTargetType: string;
    summaries: Record<string, number>;
    link: (commStyle: string) => LinkHref;
}
export const MachinesContentRow = ({ deploymentTargetType, summaries, link }: MachinesContentRowProps) => {
    const machinesCount = summaries[deploymentTargetType] || 0;
    if (!machinesCount || machinesCount === 0) {
        return null;
    }
    let commStyle = deploymentTargetType as CommunicationStyle;
    if (!Object.values(CommunicationStyleValues).includes(commStyle) || commStyle === CommunicationStyleValues.StepPackage) {
        commStyle = CommunicationStyleValues.None;
    }
    const endpointName = EndpointsHelper.getFriendlyNameFromCommStyle(commStyle);
    const endpointIcon = getCommunicationStyleIconUrl(commStyle);
    const endpointIconImage = endpointIcon && <img src={endpointIcon} className={styles.healthStatusIcon} alt="Health status"/>;
    const linkFriendlyCommStyle = getLinkFriendlyCommStyle(commStyle);
    return (<div className={styles.endpointRowsContainer} key={commStyle}>
            <div className={styles.endpointIcon}>{endpointIconImage}</div>
            <div className={styles.endpointName}>
                <InternalLink to={link(linkFriendlyCommStyle)}>{endpointName}</InternalLink>
            </div>
            <div className={styles.endpointMachinesCount}>{machinesCount.toLocaleString()}</div>
        </div>);
};
function getLinkFriendlyCommStyle(commStyle: CommunicationStyle): string {
    if (commStyle === CommunicationStyleValues.None) {
        return EndpointRegistrationKeyValues.CloudRegion;
    }
    return commStyle;
}
